import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneAcademicAchievement = createAsyncThunk(
  "GetOneAcademicAchievement/GetOneAcademicAchievement",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient =  getApiClient();
      const response = await apiClient.post(
        "api/WQ_NT_AA_AcademicAchievement/GetOneWQ_NT_AA_AcademicAchievement",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateAcademicAchievement = createAsyncThunk(
  "UpdateAcademicAchievement/UpdateAcademicAchievement",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/WQ_NT_AA_AcademicAchievement/UpdateWQ_NT_AA_AcademicAchievement",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const AcademicAchievement = createSlice({
  name: "AcademicAchievement",
  initialState: {
    //------------- GetAcademicAchievement ---------------------
    AcademicAchievement: [],
    loadingAcademicAchievement: false,
    errorAcademicAchievement: null,
    //------------- UpdateAcademicAchievement ---------------------
    UpdateAcademicAchievement: {},
    loadingUpdateAcademicAchievement: false,
    errorUpdateAcademicAchievement: null,
  },
  reducers: {
    SetAcademicAchievementState: (state, action) => {
      state.AcademicAchievement = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetOneAcademicAchievement.pending, (state, action) => {
        console.log(action.payload, "action.payload");

        state.loadingAcademicAchievement = true;
        state.AcademicAchievement = action.payload;
        state.errorAcademicAchievement = null;
      })
      .addCase(GetOneAcademicAchievement.fulfilled, (state, action) => {
        state.loadingAcademicAchievement = false;
        state.AcademicAchievement = action.payload;
      })
      .addCase(GetOneAcademicAchievement.rejected, (state, action) => {
        state.loadingAcademicAchievement = false;
        state.AcademicAchievement = action.payload;
      });
    //------------------- UpdateAttachment -----------------------------------
    builder
      .addCase(UpdateAcademicAchievement.pending, (state, action) => {
        state.loadingUpdateAcademicAchievement = true;
        state.UpdateAcademicAchievement = action.payload;
        state.errorUpdateAcademicAchievement = null;
      })
      .addCase(UpdateAcademicAchievement.fulfilled, (state, action) => {
        state.loadingUpdateAcademicAchievement = false;
        state.UpdateAcademicAchievement = action.payload;
      })
      .addCase(UpdateAcademicAchievement.rejected, (state, action) => {
        state.loadingUpdateAcademicAchievement = false;
        state.errorUpdateAcademicAchievement = action.payload;
      });
  },
});

export const {SetAcademicAchievementState} = AcademicAchievement.actions;
export default AcademicAchievement.reducer;
